package com.havn.app.core.navigation

import com.havn.app.core.designsystem.HavnIconKey

enum class HavnDestination(
    val title: String,
    val shortLabel: String,
    val icon: HavnIconKey
) {
    Auth("Agent Access", "Auth", HavnIconKey.User),
    Dashboard("Today", "Today", HavnIconKey.Today),
    Properties("Properties", "Properties", HavnIconKey.Properties),
    OpenHouses("Openings", "Openings", HavnIconKey.Calendar),
    Clients("Contacts", "Contacts", HavnIconKey.Users),
    Leads("Leads", "Leads", HavnIconKey.Leads),
    FollowUps("Follow-ups", "Follow", HavnIconKey.Check),
    Reports("Reports", "Reports", HavnIconKey.Reports),
    Tasks("Tasks", "Tasks", HavnIconKey.Check),
    Analytics("Analytics", "Analytics", HavnIconKey.Chart),
    Agency("Agency", "Agency", HavnIconKey.Building),
    Settings("Settings", "Settings", HavnIconKey.Settings);

    companion object {
        val primaryDestinations = listOf(
            Dashboard,
            Properties,
            Clients,
            OpenHouses,
            Leads,
        )

        val bottomDestinations = listOf(
            Dashboard,
            Properties,
            Clients,
            OpenHouses,
            Leads,
        )
    }
}
